var React = require('react');

function NavIconsNotebooks (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m6.5 19.22h13.29v-.89h-13.29zm.65 1.17a2.66 2.66 0 0 1 -1.79-.51 1.7 1.7 0 0 1 -.5-1.36c0-1.75 2.45-1.82 2.64-1.82h12.41v-14h-12.91c-3 .3-3.06 2.58-3.06 2.6v13.19a2.6 2.6 0 0 0 .79 2 3.34 3.34 0 0 0 2.21.74h13.12v-.88zm.76-16.78h11.09v12.21h-11.09zm-3.1 1.7c0-.07 0-1.51 2.22-1.68v12.21a4.28 4.28 0 0 0 -2.22.83z"}));
}

NavIconsNotebooks.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsNotebooks;

NavIconsNotebooks.default = NavIconsNotebooks;
